import ENDPOINTS_BASE from './/endpoints';

let protocol = 'https';
let host = 'demo.sigess.app';
let port = '8443';
const path = `${protocol}://${host}:${port}/sigess/api/`;

// Clonamos el objeto base y reemplazamos el placeholder '__PATH__'
const generateEndpoints = (basePath: string) => {
  const endpoints = JSON.parse(JSON.stringify(ENDPOINTS_BASE));
  for (const key in endpoints) {
    if (
      typeof endpoints[key] === 'string' &&
      endpoints[key].includes('__PATH__')
    ) {
      endpoints[key] = endpoints[key].replace('__PATH__', basePath);
    }
  }
  return endpoints;
};

// Exportamos 'endPoints' para que tus servicios existentes puedan importarlo
export const endPoints = generateEndpoints(path);

export const environment = {
  production: false,
  secureKey: 'dlMvbmWwxVXO3LVwhQTmnPBsaL7lSyjq',
  firma: 'https://demo.sigess.app/firma/',
  seguimientoid: 5721,
};
